import script from "./ExerciseListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExerciseListItem.vue?vue&type=script&setup=true&lang=ts"

import "./ExerciseListItem.vue?vue&type=style&index=0&id=b4211586&lang=scss"

const __exports__ = script;

export default __exports__